export const formatMoney = amount =>
  (amount / 100).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });

export const formatMoneyFlexCurrency = ({ amount, currency }) =>
  (amount / 100).toLocaleString(undefined, {
    style: "currency",
    currency,
  });
